/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Intent, Size } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { ID, POST_STATUS, SORT_TYPE } from "src/libs/interfaces/layouts"
import { Pagi } from "src/libs/useful"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { __ } from "src/libs/utilities"
import { onlyExistsArrays } from "src/libs/utilities/compareArrays"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingPrimitive, ILandingSection, ILink, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { IState, useMainStore } from "src/settings/zustand"
import { isRole } from "src/settings/zustand/user"
import getCatsWithChildren from "../../../utils/getCatsWithChildren"
import CategorySwitcher from "../../../utils/links-feed/CategorySwitcher"
import { SingleLinkDialog } from "../../landing-edit/editors/link/SingleLinkDialog"
import updateSection from "../../landing-edit/utils/updateSection"
import SingleLink, { getAvrRating } from "./SingleLink"

/* Protopia Ecosystem component */
export interface ILocalLinkFeedProps {
   primitive: ILandingPrimitive
   section?: ILandingSection
}
const LocalLinkFeed = (props: ILocalLinkFeedProps): JSX.Element => {
    const numberposts: number           = useMainStore( ( state: IState ) => state.pageCount )
    const currentLanding: ILanding      = useLandingStore( (state: ILandingStore) => state.currentLanding )
    const isEdit                        = useLandingStore((state: ILandingStore) => state.isEdit ) 
    const linkFeedCategories: ID[]      = useLandingConsoleStore( (state: ILandingConsoleStore) => state.linkFeedCategories )
    const {position}                    = usePosition( props.primitive || {position: {}} )
    const primitive: LinksFeedContent   = ( { ...props.primitive || {}, ...position.data } ) as LinksFeedContent
    
    const getCategoriesIds = () => {
        return  primitive.categoryId || 
        ( !!linkFeedCategories?.length ? linkFeedCategories : currentLanding.categories?.map(c => c.id) ) || 
        []
    } 

    const getItems = ( 
        dist : "UP" | "DOWN" = "DOWN", 
        categories?: ID[], 
        _status: POST_STATUS | undefined = undefined,
        sortType: SORT_TYPE | undefined = undefined
    ) => { 
        categories = !categories ? getCategoriesIds() : categories
        _status = !_status ? status || POST_STATUS.PUBLISH : _status
        sortType = !sortType ? sorts[0] : sortType
        const items =  [ ...(primitive.items || []) ]
            .sort((a: ILink, b: ILink) => {
                switch(sortType) {
                    case SORT_TYPE.ALPHABET:
                        return a.title?.localeCompare(b.title || "я") || 1
                    case SORT_TYPE.RATING: 
                        const r = getAvrRating( b.rating || []) - getAvrRating(a.rating || [] )
                        return r === 0 
                        ?
                        ( b.rating || []).length - ( a.rating || []).length
                        :
                        r
                    case SORT_TYPE.ORDER:
                    default:
                        return 1
                }
            })
        return (
            dist === "DOWN" 
                ? 
                items
                : 
                items.reverse() 
        )
            .filter((link:ILink)  => onlyExistsArrays( link.categoryId || [],  getCatsWithChildren( categories ) ) || !link.categoryId )
            .filter((link:ILink) =>!!( link.status === _status ))
    }

    const [ sorts, setSort ]            = useState<(SORT_TYPE)[]>([ SORT_TYPE.ORDER ])
    const [ status, setStatus ]         = useState<POST_STATUS>( POST_STATUS.PUBLISH )
    const [ allItems, setAllItems ]     = useState<ILink[]>( getItems( ) ) 
    const [ isOpen, setIsOpen ]         = useState<boolean>( false ) 
    
    const [ currentPage, setCurrentPage ] = useState<number>( 0 ) 
    const [ distination, setDistination ] = useState<"UP" | "DOWN">( "DOWN" )  
    const [ categories, setCategories ] = useState<ID[]>( getCategoriesIds() )

    useEffect(() => {
        setAllItems( getItems( distination ) )
    }, [ primitive.items ])
  
    const onItemChange = (value: any, field: string, item: ILink) => {
        const section: ILandingSection = props.section! 
        const newSection = {
            ...section,
            data: section.data.map(meat => {
                const _meat = section.data[ primitive.i || 0 ]
                if(meat.id === _meat?.id) {
                    return {
                        ..._meat,
                        items: _meat.items.map((_item: ILink) => {
                            if(_item.url ===item.url ) {
                                return {
                                    ..._item,
                                    [field]: value,
                                }
                            }
                            return _item
                        })
                    }
                }
                return meat
            })
        }
        const step: IHistoryStep = {
            prevData: JSON.parse(JSON.stringify( section )),
            data: newSection,
            type: HISTORY_TYPE.SECTION,
            title: `Edit meat`
        }
        updateSection( newSection, step )
    }
    const onAdd = (data: ILink) => {
        const section: ILandingSection = props.section! 
        const newSection = {
            ...section,
            data: section.data.map(meat => {
                const _meat = section.data[ primitive.i || 0 ]
                if(meat.id === _meat?.id) {
                    return {
                        ..._meat,
                        items: [..._meat.items, data]
                    }
                }
                return meat
            })
        }
        const step: IHistoryStep = {
            prevData: JSON.parse(JSON.stringify( section )),
            data: newSection,
            type: HISTORY_TYPE.SECTION,
            title: `Edit meat`
        }
        updateSection( newSection, step, true ) 
        setIsOpen( false )
    }

    const onCategories = (categories: ID[]) => {
        setCategories( categories )
        useLandingConsoleStore.setState({ linkFeedCategories : categories })
        setAllItems( getItems( distination, categories ) )
    }
    const onStatus = (status: POST_STATUS) => {
        setStatus( status )
        setAllItems( getItems( distination, categories, status, ) )
    }
    const onDistination = (dist: "UP" | "DOWN") => {
        setDistination( dist )
        setAllItems( getItems( dist ) )
    }
    const onSortTypes = ( sortTypes: SORT_TYPE[] ) => {
        setSort( sortTypes )
        setAllItems( getItems( distination, categories, status, sortTypes[0] ) )

    }
 

    const filteredItems = allItems
    const items = filteredItems.filter( (l, i) => i >= currentPage * numberposts && i < currentPage * numberposts + numberposts ) 
    const all = Math.ceil( filteredItems.length / numberposts ) - 1
    return <div className='pe-local-link-feed-container'>
        <div className="lead mb-2" dangerouslySetInnerHTML={{__html: primitive.title || ""}} /> 
            <CategorySwitcher 
                status={status} 
                primitive={ primitive } 
                items={ filteredItems } 
                fullCount={ allItems.length }
                categories={ categories } 
                onCategories={ onCategories } 
                onStatus={onStatus} 
                onDistination={ onDistination }
                onSortTypes={onSortTypes}
                distination={distination}
                sorts={ sorts }
            />       
            {
                (isEdit || isRole([ "administrator" ])) && <div className="my-4">
                    <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0 " icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                        <div className="smaller">
                            {__( "Add" )}
                        </div>
                    </Button> 
                    <SingleLinkDialog isOpen={ isOpen } onClose={()=>setIsOpen( false )} onAdd={ onAdd } />
                    
                </div>
            } 
            {
                (isEdit || isRole([ "administrator" ])) && <div className="my-4">
                    <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0 " icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                        <div className="smaller">
                            {__( "Add" )}
                        </div>
                    </Button> 
                    <SingleLinkDialog isOpen={ isOpen } onClose={()=>setIsOpen( false )} onAdd={ onAdd } />
                    
                    {/* */}
                </div>
            }
        <div className="row">
            { 
                !!items.length 
                    ?
                    items.map( (link: ILink, i) => <SingleLink 
                        key={ link.url } 
                        i={ i } 
                        data={ link } 
                        items={ items } 
                        primitive={ primitive }
                        columns={ primitive.columns }  
                        section={ props.section }
                        onChange={( value: any, field: string, ) => onItemChange( value, field, link )} 
                    /> ) 
                    :
                    <CalloutNoExists />
            }
        </div>
        <Pagi 
            all={  all >= 0 ? all : 0 }
            current={ Math.ceil( currentPage / numberposts ) } 
            onChoose={ n => setCurrentPage( n )}
        />
        {
            (isEdit || isRole([ "administrator" ])) && <div className="my-4">
                <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0" icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                    <div className="smaller">
                        {__( "Add" )}
                    </div>
                </Button> 
            </div>
        }
    </div>
}
export default LocalLinkFeed